import styled from 'styled-components';

export const CardHeader = styled.div`
    padding: 1.8rem 1.8rem 1.8rem 3.5rem;
    border-radius: 1.2rem;
    box-shadow: 0 0.2rem 0.5rem 0 rgba(0, 0, 0, 0.23);
    background-color: #ffffff;
    display: flex;
    position: relative;
`;
export const CabImg = styled.img.attrs(props => ({
    src: props.src || "https://gos3.ibcdn.com/dwebgosafesafep-1588933414.png",
    alt: 'Cab Image'
  }))`
    width: 12.3rem;
    height: 6.4rem;
    margin-right: 2.5rem;
    flex-shrink:0;
    border-radius: 0.6rem;
`;
export const CabDtl = styled.div(
    props => `
    flex: 1;
    display: flex;
    flex-direction: column;
    .cabDtlhHeader{
        display: flex;
        align-items: center;
        margin-bottom: 0.6rem;
        h4{
            font-family: 'Rubik';
            font-size: 2.2rem;
            color: ${props.theme.colors.black.base};
            font-weight: 600;
        }
    }
    .tagText{
        margin-left: 1rem;
        cursor: pointer;
        position: relative;
        >span{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 0.6rem;
            height: 2rem;
            border-radius: 0.8rem;
            background-color: #eef4fd;
            font-size: 1.2rem;
            color: ${props.theme.colors.goBrand.blue};
        }
    }
    .cabType{
        height: 2rem;
        border-radius: 0.2rem;
        border: solid 0.1rem #e5edf6;
        display: inline-flex;
        align-items: center;
        padding: 0 0.4rem;
        font-size: 1.2rem;
        color: ${props.theme.colors.grey.grey27};
        margin-right: 1rem;
    }
    .cabDtlFooter{
        display: flex;
        align-items: center;
    }
    .cabOfferings__list{
        display: flex;
        > li{
            display: flex;
            align-items: center;
            margin-right: 1.5rem;
            font-size: 1.2rem ;
            color: #4f525a;
        }
    }
`);

export const BookedDtl = styled.div`
    margin-left: 2rem;
    flex-shrink:0;
    font-family: 'Rubik';
    font-size: 1.2rem;
    color: #ffa280;
    p > span{
        font-weight: 600;
        color: #ff713e;
    }
`;